import React, { ReactNode } from 'react';
import * as Yup from 'yup';

import { FormSection } from '@components/Form';

export interface IWizardSectionProps {
  title: string;
  stepName?: string;
  validationSchema?: ReturnType<typeof Yup.object>;
  children: ReactNode | ReactNode[];
}

function WizardStep({ title, children }: IWizardSectionProps) {
  return <FormSection title={title}>{children}</FormSection>;
}

export default WizardStep;
